class Calculate {
    filterByCalculator(metals, calculator = 1){
        return metals.filter(metal => {
            return (metal["CalcStd"] === calculator);
        });
    }
 
    filterByGrade(metals, OKGrade = "Supra 316plus"){
        return metals.filter(metal => metal.OKGrade === OKGrade);
    }

    designStressByTemp(calcMetals, temp){
        var gradeMetals = [...calcMetals];
        var sortedMetals = gradeMetals.sort((a,b) => a.Temperature > b.Temperature ? 1 : -1);
        var lowTempIdx;
        var highTempIdx;
        
        for(var idx=0; idx<sortedMetals.length; idx++) {
            var metal = sortedMetals[idx];
           
            if(metal.Temperature >= temp){
                if(metal.Temperature === temp){
                    lowTempIdx = idx;
                    highTempIdx = idx;
                    break;
                }else{
                    lowTempIdx = idx > 0 ? idx-1 : 0;
                    highTempIdx = idx;
                    break;
                }
            }
        }

        var designStress;
        var designDiff;
        var designPerDeg;

        if(highTempIdx === lowTempIdx){
            designStress = sortedMetals[highTempIdx].DesignStress;
        } else {
            designDiff = sortedMetals[highTempIdx].DesignStress - sortedMetals[lowTempIdx].DesignStress;
            designPerDeg = designDiff / (sortedMetals[highTempIdx].Temperature - sortedMetals[lowTempIdx].Temperature);
        
            designStress = sortedMetals[lowTempIdx].DesignStress + designPerDeg * (temp - sortedMetals[lowTempIdx].Temperature);
        }

        return designStress;
    }

    metalTypeByGrade(metals, OKGrade) {
        return metals.filter(metal=>metal.OKGrade === OKGrade)[0].Micro;
    }

    minThickness(calc, tankDiameter, steelType) {
        var thickness = 0;

        switch (calc) {
            case 2:
                if (steelType !== "Carbon steel") {
                    if ((tankDiameter > 0) && (tankDiameter < 4)) {
                        thickness = 2;
                    } else if ((tankDiameter >= 4) && (tankDiameter < 10)) {
                        thickness = 3;
                    } else if ((tankDiameter >= 10) && (tankDiameter < 15)) {
                        thickness = 4;
                    } else if ((tankDiameter >= 15) && (tankDiameter < 30)) {
                        thickness = 5;
                    } else if ((tankDiameter >= 30)) {
                        thickness = 6;
                    }
                } else {
                    if ((tankDiameter > 0) && (tankDiameter < 15)) {
                        thickness = 5;
                    } else if ((tankDiameter >= 15) && (tankDiameter < 30)) {
                        thickness = 6;
                    } else if ((tankDiameter >= 30)) {
                        thickness = 8;
                    }
                }
                break;
            case 3:
                if ((tankDiameter > 0) && (tankDiameter < 50)) {
                    thickness = 0.1875;
                } else if ((tankDiameter >= 50) && (tankDiameter < 120)) {
                    thickness = 0.25;
                } else if ((tankDiameter >= 120) && (tankDiameter < 200)) {
                    thickness = 0.3125;
                } else if (tankDiameter >= 200) {
                    thickness = 0.375;
                }
                break;
            default:
                if ((tankDiameter > 0) && (tankDiameter < 15)) {
                    thickness = 5;
                } else if ((tankDiameter >= 15) && (tankDiameter < 36)) {
                    thickness = 6;
                } else if ((tankDiameter >= 36) && (tankDiameter < 60)) {
                    thickness = 8;
                } else if (tankDiameter >= 60) {
                    thickness = 10;
                }
                break;
        }

        return thickness;
    }

    calculateThickness(i, calc, diam, actHeight, plateWidth, dens, designStress, jointF, steelType, corrAllow) {
        var minTh = 0;

        if (calc === 1) {
            /* Original */
            minTh = (((4.9 * diam) * (actHeight - 0.3) * dens) / (designStress * jointF)) + corrAllow;

            /* new 0.1.2022 */
            //minTh = (4.9 * ( diam * dens * ((actHeight - (jointF * (i * plateWidth))) - 0.3)) / designStress) + corrAllow;
            //minTh = (4.9 * ( diam * dens * ((actHeight - (jointF * plateWidth)) - 0.3)) / designStress) + corrAllow;
        } else if (calc === 2) {
            /* Original */
            minTh = (diam / (20 * designStress)) * (98 * dens * (actHeight - 0.3)) + corrAllow;
            /* new 0.1.2022 */
            // minTh = (diam / (20 * designStress)) * (98 * dens * (actHeight - (i * plateWidth) - 0.3)) + corrAllow;


        } else if (calc === 3) {
            /* Original */
            minTh = (((2.6 * diam) * (actHeight - 1) * dens) / ((designStress * 1000) * jointF)) + corrAllow;
            
            // minTh = (((2.6 * diam) * (actHeight - (jointF * (i * plateWidth)) - 1) * dens) / (( designStress * 1000 ))) + corrAllow;
        }
        
        //var stdMinThickness = this.minThickness(calc, diam, steelType);
        /*
        // if (minTh > stdMinThickness + corrAllow) {
        if (minTh > stdMinThickness) {
            if (calc !== 3) {
                return minTh;
            } else {
                return minTh;
            }
        } else {
            // return stdMinThickness + corrAllow;
            return stdMinThickness;
        }
        */

        return minTh;
    }

    calculateMinThickness(calc, diam, steelType, thickness){

        /* API 650 Metric Units */
        var minThick = 0;

        if(calc == 1){
            minThick = 10;

            if(diam < 15){
                minThick = 5;
            }else if(diam < 36){
                minThick = 6;
            }else if(diam < 60){
                minThick = 8;
            }
            
        /* EN 14015 Metric Units */
        }else if(calc == 2){
            if(steelType == "Carbon"){
                minThick = 12;

                if(diam < 15){
                    minThick = 5;
                }else if(diam < 30){
                    minThick = 6;
                }else if(diam < 60){
                    minThick = 8;
                }else if(diam < 90){
                    minThick = 10;
                }
            }else{
                minThick = 6;

                if(diam < 4){
                    minThick = 2;
                }else if(diam < 10){
                    minThick = 3;
                }else if(diam < 15){
                    minThick = 4;
                }else if(diam < 30){
                    minThick = 5;
                }
            }
        /* API 650 Customary Units */
        }else{
            minThick = 3/8;

            if(diam < 50){
                minThick = 3/16;
            }else if(diam < 120){
                minThick = 1/4;
            }else if(diam < 200){
                minThick = 5/16;
            }
        }

        if(thickness < minThick) thickness = minThick;

        return thickness;
    }

    tankSectionsCalc(calc, designStress, height, diam, dens, jointF, plateWidth, steelType, corrAllow){
        var actHeight = height;
        var result = [];

        var i = 0;
        while (actHeight > 0) {
            var section = {thickness:0, width:0};
            
            section.thickness = this.calculateThickness(i, calc, diam, actHeight, plateWidth, dens, designStress, jointF, steelType, corrAllow);
            
            /** check minimum thickness by diameter */
            section.thickness = this.calculateMinThickness(calc, diam, steelType, section.thickness);

            if (calc !== 3) {
                if (actHeight < plateWidth / 1000) {
                    section.width = actHeight * 1000;
                } else {
                    section.width = plateWidth;
                }

                result.push(section);
                actHeight -= plateWidth / 1000;
            } else {
                if (actHeight < plateWidth) {
                    section.width = actHeight;
                } else {
                    section.width = plateWidth;
                }

                result.push(section);
                actHeight -= plateWidth;
            }

            i++;
        }

        return result;
    }

    ConvToMM(value, uom) {
        var ret = 0;

        switch (uom) {
            case "ft":
                ret = value * 304.8;
                break;
            case "inch":
                ret = value * 25.4;
                break;
            default:
                ret = value;
                break;
        }

        return ret;
    }

    ConvToM(value, fromUom) {
        var ret = 0;

        switch (fromUom) {
            case "ft":
                ret = (value * 304.8) / 1000;
                break;
            case "inch":
                ret = (value * 25.4) / 1000;
                break;
            default:
                ret = value / 1000;
                break;
        }

        return ret;
    }

    calcMtrlConsumption(calc, sections, steelDensity, diam) {
        var weight = 0;
    
        for (var i = 0; i < sections.length; i++) {
            var thickness = sections[i].thickness;
            var width = sections[i].width;
            var diameter = diam;
    
            if (calc === 3) {
                thickness = this.ConvToMM(thickness, "inch");
                width = this.ConvToMM(width, "ft");
                diameter = this.ConvToM(diameter, "ft");
            }
            
            var sectionVolume = (thickness / 100) * (width / 100) * (Math.PI * (diameter * 10));
            var sectionWeight = (steelDensity * sectionVolume);
    
            weight += sectionWeight;
        }
    
        return weight;
    }
}

export default Calculate;